import * as yup from "yup";

import * as MESSAGES from "../messages";

export const createIndicatorSchema = yup.object().shape({
  name: yup.string().required(MESSAGES.REQUIRE_MESSAGE).trim(),
});
